module.exports = __webpack_public_path__ + "img/checklist-green.4a282119.svg";